if (!customElements.get('modal-dialog')) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this)
      );
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.hide();
        }
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
        });
      }

      // Focus trap: mientras el modal esta abierto (aria-modal), Tab/Shift+Tab
      // ciclan solo entre los focables internos y no llegan al fondo.
      this.onTrapKeydown = (event) => {
        if (event.key !== 'Tab' || !this.hasAttribute('open')) return;
        const focusables = this.getFocusableElements();
        const dialog = this.querySelector('[role="dialog"]');
        if (!focusables.length) {
          event.preventDefault();
          dialog?.focus();
          return;
        }
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        const active = document.activeElement;
        if (event.shiftKey) {
          if (active === dialog || active === first || !this.contains(active)) {
            event.preventDefault();
            last.focus();
          }
        } else if (active === dialog || active === last || !this.contains(active)) {
          event.preventDefault();
          first.focus();
        }
      };
      document.addEventListener('keydown', this.onTrapKeydown);
    }

    // Origen exacto del iframe para postMessage (evita el comodin '*').
    // Cubre youtube.com, youtube-nocookie.com y player.vimeo.com.
    getIframeOrigin(iframe, fallback) {
      if (!iframe.src) return fallback;
      try {
        return new URL(iframe.src, window.location.href).origin;
      } catch (e) {
        return fallback;
      }
    }

    getFocusableElements() {
      return Array.from(this.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((el) => el.offsetParent !== null && !el.closest('[inert]'));
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }

    show(opener) {
      this.openedBy = opener;
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');

      setTimeout(() => {
        this.querySelector('[role="dialog"]').focus();
      }, 100);
    }

    hide() {
      if (this.querySelector('#Product-Modal-Content') && Shopify.DesignMode) {
        return;
      }
      this._quickViewController?.abort();
      this._quickViewController = null;
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      this.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', this.getIframeOrigin(video, 'https://www.youtube.com'));
      });
      this.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', this.getIframeOrigin(video, 'https://player.vimeo.com'));
      });
      this.querySelectorAll('video').forEach((video) => video.pause());
      if (this.querySelector('#Product-Modal-Content')) {
        this.querySelector('#Product-Modal-Content').innerHTML = '';
      }
      if (this.querySelector('.compare-lightbox--data')) {
        this.querySelector('.compare-lightbox--data').innerHTML = '';
      }
      // Devuelve el foco al disparador cuando el modal se abrio via show(opener).
      if (this.openedBy && typeof this.openedBy.focus === 'function' && this.openedBy.isConnected) {
        this.openedBy.focus();
      }
      this.openedBy = null;
    }
  }
  customElements.define('modal-dialog', ModalDialog);
}
if (!customElements.get('modal-opener')) {
  class ModalOpener extends HTMLElement {
    constructor() {
      super();

      const button = this.querySelector('button');

      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define('modal-opener', ModalOpener);
}
